import { LySnackBarService } from '@alyle/ui/snack-bar/snack-bar.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Partner } from 'src/app/shared/models/partner';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-add-partner-modal',
  templateUrl: './add-partner-modal.component.html',
  styleUrls: ['./add-partner-modal.component.scss']
})
export class AddPartnerModalComponent {

  //binds to input field in modal
  newPartnerName: string = '';

  constructor(private userService: UserService, private partnerService: PartnerService, private snackbarService: SnackBarService, public dialogRef: MatDialogRef<AddPartnerModalComponent>) { }

  onClose(): void {
    this.dialogRef.close();
  }

  addNewPartner() {

    if (this.newPartnerName) {
      let partner: Partner = {
        id: null,
        name: this.newPartnerName,
        earningsYTD: 0,
        proStatus: 'Incomplete',
        shows: [],
        membershipIds: []
      };

      this.partnerService.addNewPartner(partner, this.userService.currentUser.id).subscribe(
        (resPartner) => {

          //call snackbar for success message
          this.snackbarService.showSnackBarMessage("Partner successfully added!", 'Close')

          this.onClose();
        },
        (error) => {

          if (error.error.error.toLowerCase().includes('duplicate key value violates')) {
            this.snackbarService.showSnackBarMessage("Partner name already in use. Please choose a different name.", 'Close', undefined, true);
          }
          else {
            //call snackbar for error message
            this.snackbarService.showSnackBarMessage("An error occurred while attempting to add the partner.", 'Close', undefined, true);
          }

        }
      );
    }
    else {
      //call snackbar to display error message
      this.snackbarService.showSnackBarMessage("Invalid name provided for partner.", 'Close', undefined, true);

    }


  }
}
